/* eslint-disable max-len */
import React from 'react';

 const SVGIconBin = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="Group_6454"
        data-name="Group 6454"
        transform="translate(-1537 488)"
      >
        <rect
          id="BG"
          width="20"
          height="20"
          rx="4"
          transform="translate(1537 -488)"
          fill="rgba(255,255,255,0)"
        />
        <path
          id="trash-solid"
          className="SVGIcon_colorFill"
          d="M3.169.415A.749.749,0,0,1,3.839,0H6.661a.749.749,0,0,1,.67.415L7.5.75H9.75a.75.75,0,0,1,0,1.5h-9a.75.75,0,0,1,0-1.5H3Zm6.084,10.51A1.127,1.127,0,0,1,8.13,12H2.37a1.128,1.128,0,0,1-1.123-1.076L.729,3H9.75Z"
          transform="translate(1542 -484)"
          fill="#a73d3d"
        />
      </g>
    </svg>
  );
};

export default SVGIconBin